/**
 * Quel écran montrer sur la page d'invitation ? (05/10/2026)
 *
 * Avant, la page restait indéfiniment sur « Vérification de votre session… » :
 * elle attendait que le magasin d'authentification sorte de l'état `loading`,
 * mais ne demandait jamais la session (`fetchMe`), et aucun autre écran ne le
 * faisait à sa place quand on arrivait directement par le lien de l'e-mail.
 *
 * La décision est isolée ici, sans React, pour qu'on puisse vérifier que CHAQUE
 * combinaison d'états aboutit à un écran précis, jamais à une attente sans fin.
 */
export type TypeErreurInvitation = 'introuvable' | 'lien' | 'reseau';

export interface EntreeEtatInvitation {
  token: string | null;
  /** Lecture de l'invitation : `null` = pas encore de réponse. */
  invitation: { email: string } | null;
  erreurInvitation: TypeErreurInvitation | null;
  /** La session a-t-elle été interrogée (réponse, refus ou délai dépassé) ? */
  sessionPrete: boolean;
  user: { email: string } | null;
  rejoint: boolean;
}

export type EtatInvitation =
  | 'lien-incomplet'
  | 'invitation-invalide'
  | 'erreur-reseau'
  | 'chargement-invitation'
  | 'rejoint'
  | 'verification-session'
  | 'mauvais-compte'
  | 'accepter'
  | 'connexion';

export function etatInvitation(e: EntreeEtatInvitation): EtatInvitation {
  if (!e.token) return 'lien-incomplet';
  if (e.invitation) {
    if (e.rejoint) return 'rejoint';
    if (!e.sessionPrete) return 'verification-session';
    if (!e.user) return 'connexion';
    return e.user.email.toLowerCase() === e.invitation.email.toLowerCase() ? 'accepter' : 'mauvais-compte';
  }
  if (e.erreurInvitation === 'reseau') return 'erreur-reseau';
  if (e.erreurInvitation === 'lien') return 'lien-incomplet';
  if (e.erreurInvitation === 'introuvable') return 'invitation-invalide';
  return 'chargement-invitation';
}

/** Classe l'erreur de lecture : 404 = invitation introuvable/expirée/utilisée, 400 = lien incomplet, le reste = réseau/serveur. */
export function typeErreurInvitation(e: unknown): TypeErreurInvitation {
  const statut = (e as { status?: number } | null)?.status;
  if (statut === 404 || statut === 410) return 'introuvable';
  if (statut === 400) return 'lien';
  return 'reseau';
}
